// eslint-disable-next-line jira/filename-case
import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { HorizontalNavSkeleton } from '@jira/navigation-apps__horizontal-nav-common/src/ui/horizontal-nav-skeleton/index.tsx';
import { customPracticeQueueRoute } from '@jira/router-routes__servicedesk-queue-routes/src/customPracticeQueueRoute.tsx';
import { customIssueRoute } from '@jira/router-routes__servicedesk-queue-routes/src/customIssueRoute.tsx';
import { useCurrentRoute } from '@jira/platform__utils-router/src/index.tsx';
import { usePathParam } from '@atlassian/react-resource-router';
import { LazyHorizontalNavQueueForPaint } from './async-for-paint.tsx';

export const AsyncHorizontalNavQueue = (): false | React.JSX.Element => {
	const route = useCurrentRoute();
	const [issueKey] = usePathParam('issueKey');

	const isIssueView =
		route.name === customIssueRoute.name ||
		(route.name === customPracticeQueueRoute.name && issueKey);

	const content = !isIssueView && (
		<Placeholder name="horizontal-nav-queue" fallback={<HorizontalNavSkeleton />}>
			<LazyHorizontalNavQueueForPaint />
		</Placeholder>
	);

	return content;
};
